import { render, staticRenderFns } from "./ProposalQuestionnaireResult.vue?vue&type=template&id=56d1db44&scoped=true"
import script from "./ProposalQuestionnaireResult.vue?vue&type=script&lang=js"
export * from "./ProposalQuestionnaireResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1db44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d1db44')) {
      api.createRecord('56d1db44', component.options)
    } else {
      api.reload('56d1db44', component.options)
    }
    module.hot.accept("./ProposalQuestionnaireResult.vue?vue&type=template&id=56d1db44&scoped=true", function () {
      api.rerender('56d1db44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/components/ProposalQuestionnaireResult.vue"
export default component.exports